import moment from 'moment';
import { useQuery } from '../../../../../hooks/UseQuery';
import React from 'react';
import { TableInput } from '../../../../../components/common';

interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
}
const TFoot = ({ moduleData, updateModuleData }: any) => {
  const isView = useQuery('isView') === 'true' ? true : false;
  const handleInputChange = (
    fieldName: string,
    value: string | number | null
  ) => {
    updateModuleData('key-pair', null, fieldName, { [fieldName]: value });
  };

  return (
    <tfoot>
      <tr>
        <th colSpan={1} align="left">
          comments/Remarks
        </th>
        <th colSpan={7}>
          <TableInput
            isView={isView}
            style={{}}
            name="comment"
            type="text"
            value={moduleData.comment}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleInputChange(e.target.name, e.target.value)
            }
          />
        </th>
      </tr>
    </tfoot>
  );
};

export default React.memo(TFoot);
